import { BASE_URL, INDIAN_MSME_USER_TOKEN } from "../../utils/Constants";
import { RootState } from "..";
import axios from "axios";
import { ThunkAction } from "redux-thunk";
import VendorType, {
  AddVendor,
  DeleteVendor,
  GetVendor,
  UpdateVendor,
} from "../types/VendorType";
import { getCookie } from "../../utils/CookieAction";
import LogoutAction from "./LogoutAction";
import DeliveryAreaType, {
  AddDeliveryArea,
  DeleteDeliveryArea,
  GetDeliveryArea,
  UpdateDeliveryArea,
} from "../types/DeliveryAreaType";

interface Action {
  type: string;
  payload?: any;
  message?: string;
}

const DeliveryAreaAction = {
  addDeliveryArea:
    (data: AddDeliveryArea): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const vendorData: any = await axios.post(
          BASE_URL + "delivery-area/create",
          {
            state: data.state,
            city: data.city,
            amount: data.amount,
            min_order_amount: data.min_order_amount,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              "Content-Type": "multipart/form-data",
            },
          }
        );
        dispatch({
          type: "",
          payload: {
            type: "",
            status: vendorData.data.status,
          },
        });

        return vendorData.data;
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getDeliveryArea:
    (data: GetDeliveryArea): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "delivery-area/list",
          {
            search: data.search,
            limit: data.limit,
            page: data.page,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        console.log(result);

        dispatch({
          type: DeliveryAreaType.SET_DELIVERY_AREA_LIST,
          payload: {
            data: result.data.data.data,
            currentPage: result.data.data.current_page,
            lastPage: result.data.data.last_page,
            totalData: result.data.data.total,
            from: result.data.data.from,
            to: result.data.data.to,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  updateDeliveryArea:
    (data: UpdateDeliveryArea): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "delivery-area/update",
          {
            id: data.id,
            state: data.state,
            city: data.city,
            amount: data.amount,
            min_order_amount: data.min_order_amount,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              "Content-Type": "multipart/form-data",
            },
          }
        );

        dispatch({
          type: "",
          payload: {
            type: "",
            status: result.data.status,
          },
        });

        dispatch({
          type: "",
        });

        return result.data;
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  deleteDeliverArea:
    (data: DeleteDeliveryArea): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

        const result: any = await axios.get(
          BASE_URL + "delivery-area/delete/" + data.id,
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
            },
          }
        );
        dispatch({
          type: "",
          payload: {
            type: "",
            status: result.data.status,
          },
        });
        dispatch({
          type: "",
        });
        return result.data;
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
};

export default DeliveryAreaAction;
